let overtimeClinic = [
  {
    path: '/doctor_overtimeclinic_index',
    name: '加班门诊',
    component: () => import('@/pages/overtimeClinic/overtime_clinic_index')
  },
  {
    path: '/overtimeclinic_consult',
    name: '加班门诊',
    component: () => import('@/pages/overtimeClinic/overtime_clinic_consult')
  },
  {
    path: '/overtimeclinic_order',
    name: '支付',
    component: () => import('@/pages/overtimeClinic/overtime_clinic_pay_order')
  },
  {
    path: '/overtimeclinic_chat',
    name: '聊天室',
    component: () => import('@/pages/overtimeClinic/overtime_clinic_chat')
  },
  {
    path: '/overtimeclinic_detail',
    name: '订单详情',
    component: () => import('@/pages/overtimeClinic/overtime_clinic_detail')
  }
]

export default overtimeClinic
